import { useEffect, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';
import { usePlatformStore } from '../stores/platform.store';

/**
 * Platform (Custel operatör) korumalı route wrapper.
 * - Henüz kontrol edilmediyse `GET /platform/staff/me` ile oturumu doğrular.
 * - Platform personeli değilse `/giris`e yönlendirir.
 *
 * `RequireAuth` ile aynı yapı, fakat `usePlatformStore` kullanır — tenant
 * (müşteri) oturumundan bağımsızdır.
 */
export function RequirePlatform({ children }: { children: ReactNode }) {
  const { t } = useTranslation('components');
  const { staff, hasChecked, isLoading, fetchPlatformSession } = usePlatformStore();
  const location = useLocation();

  useEffect(() => {
    if (!hasChecked) {
      void fetchPlatformSession();
    }
  }, [hasChecked, fetchPlatformSession]);

  if (!hasChecked || isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-custel-krem">
        <p className="text-sm text-custel-text-secondary">{t('guard.platformLoading')}</p>
      </div>
    );
  }

  if (!staff) {
    return <Navigate to="/giris" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
